import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import type { ScopedBinding } from "@/app/types";
import { getEngineApi } from "@/lib/api";
import { useResourceScope } from "@/lib/resource-context";
import { sessionVerificationQueryOptions } from "./get-session-verification";
import { sessionVerificationKeys } from "./query-keys";
import {
  type UpdateSessionVerificationRequest,
  updateSessionVerification,
} from "./update-session-verification";

export const useGetSessionVerification = (
  binding: ScopedBinding = "project"
) => {
  const scope = useResourceScope();

  return useSuspenseQuery({
    ...sessionVerificationQueryOptions({ binding, scope }),
  });
};

export const useUpdateSessionVerification = (
  binding: ScopedBinding = "project"
) => {
  const scope = useResourceScope();
  const client = getEngineApi(scope, binding);

  return useMutation({
    mutationFn: (settings: UpdateSessionVerificationRequest) =>
      updateSessionVerification({ client, settings }),
    meta: {
      invalidates: [sessionVerificationKeys.all({ scope })],
      errorMessage: "Failed to save settings",
    },
    onSuccess: () => {
      toast.success("Settings saved successfully");
    },
  });
};
